import { faGift } from '@fortawesome/free-solid-svg-icons';

import { ContentCard } from 'apps/dashboard/shared/scripts/components';
import { Icon, LabelValue } from 'apps/shared/scripts/components';
import { useDeliveryByCardId } from 'apps/shared/scripts/graphql';
import { formatDateYear } from 'apps/shared/scripts/utils';

import {
  bodyClassName,
  headerClassName,
  headingClassName,
  iconClassName,
  iconWrapperClassName,
} from './styles';

interface Props {
  cardId: string;
}

const CardDelivery = ({ cardId }: Props) => {
  const { delivery, isLoading } = useDeliveryByCardId({
    variables: { cardId },
  });

  if (isLoading || !delivery) {
    return null;
  }

  return (
    <ContentCard>
      <div className={headerClassName}>
        <div className={iconWrapperClassName}>
          <Icon className={iconClassName} fa={faGift} />
        </div>
        <h2 className={headingClassName}>Delivery</h2>
      </div>
      <div className={bodyClassName}>
        <LabelValue label="Method" value={delivery.method} />
        {delivery.recipientEmail && (
          <LabelValue label="Recipient" value={delivery.recipientEmail} />
        )}
        <LabelValue
          label="Delivered on"
          value={formatDateYear(delivery.createdAt)}
        />
      </div>
    </ContentCard>
  );
};

CardDelivery.displayName = 'CardDelivery';

export default CardDelivery;
